<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="User Route Log" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue">
                                <b-table :items="history" :fields="tablefields" :per-page="perPage" :filter="filter" show-empty stacked="md">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(created_at)="row">
                                        <div v-if="row.item.created_at" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_at.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_at.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-between align-items-center" style="gap: 28px;">
                                <span style="display: flex; gap: 4px; min-width: fit-content;"> 
                                    <span>
                                        <!-- First Page Button (<<) -->
                                        <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                            <b-icon icon="chevron-double-left"></b-icon>
                                        </button>

                                        <!-- Previous Page Button (<) -->
                                        <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                            <b-icon icon="chevron-left"></b-icon>
                                        </button>
                                    </span>

                                    <!-- Page Number Display (Page X of Y) -->
                                    <span class="align-self-center">
                                        <span class="align-self-center">
                                            <span class="d-flex align-items-center" style="gap: 6px; padding: 0px 8px;">
                                                <span>Page</span>
                                                <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                                <span>of {{ totalPages }}</span>
                                            </span>
                                        </span>
                                    </span>

                                    <span>
                                        <!-- Next Page Button (>) -->
                                        <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                            <b-icon icon="chevron-right"></b-icon>
                                        </button>

                                        <!-- Last Page Button (>>) -->
                                        <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                            <b-icon icon="chevron-double-right"></b-icon>
                                        </button>
                                    </span>
                                </span>
                                <div style="min-width: 200px; display: flex; align-items: center;">
                                    <span style="width: 160px;">Per page:</span> <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
               {
                    key: 'user',
                    label: 'User',
                    sortable: false
                },
                {
                    key: 'from_route',
                    label: 'Route From',
                    sortable: false
                },
                {
                    key: 'to_route',
                    label: 'Route To',
                    sortable: false
                },
                {
                    key: 'created_at',
                    label: 'Created At',
                    sortable: false
                }
            ],

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            initialLoad: true,
            loadingPage: false,
            pageOptions: [20, 30, 50]
        };
    },

    computed: {
        ...mapState({
            count: state => state.subscriber.route_count,
            history: state => state.subscriber.route_log,
            loading: state => state.subscriber.routeLoading,
            error: state => state.subscriber.routeError
        }),
        
        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                
                this.$router.replace({
                    path: '/subscription/user/route-log',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                
                this.currentPage = newCurrentPage
                this.$store.dispatch("subscriber/fetchRouteLog", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                
                this.$router.replace({
                    path: '/subscription/user/route-log',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("subscriber/fetchRouteLog", {
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    mounted() { 
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        fetchInitial() {
            this.$store.dispatch("subscriber/fetchRouteLog", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        }
    }
};
</script>
